/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_Q7Inputs */

const en_to_typescript_faq_q7 = /** @type {(inputs: To_Typescript_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should I use generated types or a schema?`)
};

const ko_to_typescript_faq_q7 = /** @type {(inputs: To_Typescript_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성된 타입을 써야 하나요, 스키마를 써야 하나요?`)
};

const ja_to_typescript_faq_q7 = /** @type {(inputs: To_Typescript_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成された型を使うべきですか、スキーマを使うべきですか`)
};

/**
* | output |
* | --- |
* | "Should I use generated types or a schema?" |
*
* @param {To_Typescript_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_q7 = /** @type {((inputs?: To_Typescript_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_q7(inputs)
	if (locale === "ko") return ko_to_typescript_faq_q7(inputs)
	return ja_to_typescript_faq_q7(inputs)
});